// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data_search .search-input input{color:#fff;background-color:rgba(0,0,0,.2);border:none}", ""]);
// Exports
module.exports = exports;
